module.exports = __webpack_public_path__ + "img/轮播右翻滚.828f763f.svg";